import { transparentize } from 'polished';
import styled, { keyframes } from 'styled-components';

export const Container = styled.div<{ selectedOrderId: number | string | null }>`
  width: ${(p) => (p.selectedOrderId !== null ? '0px' : '100%')};
  height: ${(p) => (p.selectedOrderId !== null ? '0px' : 'initial')};
  overflow: ${(p) => (p.selectedOrderId !== null ? 'hidden' : 'initial')};
  display: flex;
  flex-direction: column;
  transition: width 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  scrollbar-width: thin;
  scrollbar-color: black transparent;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a1a1a1;
  }

  @media (min-width: 768px) {
    /* min-width: 300px; */
    flex: 1;
    max-width: 300px;
    height: initial;
    display: flex;
    overflow-y: auto;
  }

  div.header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    width: 100%;
    height: min-content;
  }

  div.header__title {
    display: flex;
    justify-content: space-between;

    h1 {
      font-size: 1.2rem;
      font-weight: 600;
    }

    div {
      display: flex;
      background: #f5f5f5;
      padding: 5px;
      border-radius: 4px;
      min-height: 30px;
      min-width: 30px;
      justify-content: center;
    }
  }

  div.header__filter {
    display: flex;
    gap: 16px;

    .header__filter__button {
      cursor: pointer;
      background: #329bfc;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      width: 38px;
      height: 38px;
    }
  }

  .new__order {
    cursor: pointer;
    background: #329bfc;
    color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 4px;
    height: 38px;
    width: 100%;
    font-size: 14px;
    font-family: Sora, sans-serif;
    font-weight: 600;
    text-decoration: none;
  }

  .header__filter__fast {
    font-size: 0.9rem;
    display: flex;
    gap: 16px;
    justify-content: center;

    div {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px;
      background: #f5f5f5;
      border-radius: 4px;
      flex: 1;
      max-width: 200px;
      cursor: pointer;

      div {
        width: 20px;
        height: 20px;
        display: flex;
        background: #ececec;
        align-items: center;
        justify-content: center;
        padding: 0px;
        flex: none;
      }
    }

    .emphasis {
      color: #329bfc;
      background: ${() => transparentize(0.9, '#329bfc')};
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
  }

  .footer {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px;

    div {
      display: flex;
      gap: 8px;
      font-size: 0.9rem;

      p {
        font-weight: 600;
      }

      span {
        font-weight: 400;
      }
    }
  }
`;

export const Divider = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid rgba(124, 141, 181, 0.25);
`;

export const PedidoItem = styled.div<{ color: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px;
  gap: 16px;
  cursor: pointer;

  div.etiquetas {
    display: flex;
    width: 100%;
    gap: 8px;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px;
      background: #f5f5f5;
      border-radius: 4px;
      height: 24px;
      padding: 0 8px;

      p {
        font-size: 0.8rem;
        font-weight: 400;
      }
    }

    .etiquetas__estagio {
      background: ${(p) => transparentize(0.9, p.color)};
      color: ${(p) => p.color};
    }

    .etiquetas__agendado {
      background: ${() => transparentize(0.9, '#FF8946')};
      color: #ff8946;
    }
  }

  div.information {
    display: flex;
    gap: 12px;
    align-items: center;

    .information__icon {
      display: flex;
      width: 40px;
      height: 40px;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
    }

    .delivery {
      background: ${() => transparentize(0.9, '#ff2190')};
    }

    .withdrawal {
      background: ${() => transparentize(0.9, '#FF8946')};
    }

    .information__text {
      h2 {
        font-size: 0.9rem;
        font-weight: 600;
      }

      p {
        font-size: 0.8rem;
        font-weight: 400;
        color: #7c8db5;
      }
    }
  }
`;

const pulse = keyframes`
  0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 #F64444;
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 4px rgba(0, 0, 0, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
`;

export const Blob = styled.span`
  position: absolute;
  top: 0;
  right: 0;

  background: ${({ theme }) => theme.colors.red};
  border-radius: 50%;
  margin: 4px;
  height: 10px;
  width: 10px;

  box-shadow: 0 0 0 0 ${({ theme }) => theme.colors.red};
  transform: scale(1);
  animation: ${pulse} 2s infinite;
`;